<template>
  <div class="my-5 md:my-10 max-w-7xl px-5 mx-auto pb-20">
    <div v-if="loading">
      <p class="text-center py-20 lg:pt-40">Finding Articles...</p>
    </div>
    <div
      class="p-2.5 sm:px-5 xl:px-0 sm:py-5 sm:grid grid-cols-2 lg:grid-cols-3 sm:auto-rows-fr gap-5"
    >
      <post-preview
        v-for="(post, index) in sortedPosts"
        :key="index"
        :post="post"
        class=" mb-5 md:mb-0"
      ></post-preview>
    </div>
    <div v-if="!loading && showLoadMore" class="my-5">
      <button class="button mx-auto" @click.prevent="loadNextPage">
        View more articles
      </button>
    </div>
    <div v-if="error" class="py-20">
      <p class="text-center mb-10">{{ error }}</p>
      <button class="button mx-auto" @click.prevent="tryAgain">Try again</button>
    </div>
  </div>
</template>

<script>
import PostPreview from './PostPreview.vue';
import Route from '../src/Route';

export default {
  components: { PostPreview },

  data() {
    return {
      posts: [],
      perPage: 15,
      currentPage: 1,
      lastPage: null,
      total: null,
      loading: false,
      error: null,
    };
  },

  computed: {
    sortedPosts() {
      return this.posts.sort(function(a, b) {
        return Date.parse(a.publish_at) - Date.parse(b.publish_at);
      });
    },

    showLoadMore() {
      return this.currentPage !== this.lastPage && !this.error;
    },
  },

  created() {
    this.getPosts();
  },

  methods: {
    getPosts() {
      this.loading = true;
      this.error = null;

      axios
        .get(Route('posts.index-json'), {
          params: {
            page: this.currentPage,
          },
        })
        .then((response) => {
          if (response.status === 200) {
            this.posts = [...this.posts, ...response.data];
            this.lastPage = response.data.last_page;
            this.currentPage = response.data.current_page;
            this.total = response.data.total;
          } else {
            throw 'There was a problem.';
          }
        })
        .catch((error) => {
          this.error = 'Sorry there was a problem.';
        })
        .then(() => {
          this.loading = false;
        });
    },

    loadNextPage() {
      ++this.currentPage;
      this.getPosts();
    },

    tryAgain() {
      this.getPosts();
    },
  },
};
</script>
